// Org flavour vocabulary. Must stay in sync with the backend Org.Flavour
// text choices (power_backend/org/models.py). Flavour drives what users see
// (default feature flags at creation, UI terminology); building type drives
// benchmarking cohorts. Neither ever writes the other.
export const FLAVOUR_OPTIONS = [
    { value: 'school', label: 'School' },
    { value: 'university', label: 'University / college' },
    { value: 'estate', label: 'Estate / property portfolio' },
    { value: 'business', label: 'Business / multi-site operator' },
    { value: 'home', label: 'Home / single household' }
]

export const FLAVOUR_VALUES = FLAVOUR_OPTIONS.map((opt) => opt.value)

// Suggestion only — shown as helper text in the org form, never auto-applied.
// `hotel` suggests `business` rather than `estate`: a hotel trades from its sites rather than
// letting them, so it wants Sites/Closures, not Properties/voids. `care_home` stays `estate`,
// where residents are closer to occupants of a managed property than customers of a trading site.
// Pubs, restaurants, shops and leisure centres suggest `business` for the same reason as hotels:
// each site trades with customers, so the operator wants Sites, opening hours and Closures.
export const SUGGESTED_FLAVOUR_BY_BUILDING_TYPE = {
    school: 'school',
    university: 'university',
    domestic: 'home',
    office: 'estate',
    local_authority: 'estate',
    care_home: 'estate',
    hotel: 'business',
    pub: 'business',
    restaurant: 'business',
    retail: 'business',
    leisure: 'business',
    leisure_pool: 'business'
}

export function flavourLabel(value) {
    return FLAVOUR_OPTIONS.find((opt) => opt.value === value)?.label ?? value
}
